import type { IBrandConfig } from './types';

const ANPAC_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: { kind: 'cms', path: 'policy/tou/idg-subbrand-privacy.md' },
  termsOfService: { kind: 'cms', path: 'policy/tou/idg-subbrand-terms.md' },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  /* The idg-subbrand brands are the only ones Angular gives an Identity Theft
     Protection document to. */
  idTheftProtection: {
    kind: 'cms',
    path: 'policy/tou/idg-subbrand-theft-protection.md',
  },
  defaultBillingCategoryKey: 'identityguard_fi',
  copyRightEntity: 'Intersections LLC dba Pango',
  carouselBanners: true,
  security: true,
  licensor: 'intersections',
  vaultProject: 'identityguard_watson',
  plan: true,
  finishSetup: false,
  adaChat: false,
  hasCustomerServiceSupport: true,
  secureUpload: true,
  accountDetails: true,
  dwEmailVerification: {
    adaChat: false,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday – Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    customerSupportTitle: {
      active: true,
      title: 'You can reach our customer care team:',
      availability:
        'Customer care representatives are available Monday – Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      availability: (
        <>
          Monday – Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    mail: {
      active: true,
      address: 'PO Box 52330 Boston, MA 02205',
      customerSupport: false,
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
};

export default ANPAC_BRAND_CONFIG;
